export default __webpack_public_path__ + "static/media/application-screenshots-04.222173e5.jpg";